import dynamic from "next/dynamic";

export const BlogPostHero = dynamic(() => import("./component"));
